<div class="detail-container">

  <!-- HEADER -->
  <div class="page-header">

    <div class="header-left">

      <button mat-icon-button type="button" (click)="back()" matTooltip="Zurück zur Projektübersicht">

        <mat-icon>arrow_back</mat-icon>

      </button>


      <div class="header-titles">

        <h1 class="page-title">
          {{ projekt?.name || 'Projekt' }}
        </h1>

        <span class="page-sub" *ngIf="projekt">

          {{ projekt.projektNummer }}

        </span>

      </div>

    </div>


    <div class="header-actions" *ngIf="projekt">

      <button mat-raised-button color="primary" type="button" (click)="ibnAssistentStarten()"
        matTooltip="Schritt für Schritt durch eine Inbetriebnahme">

        <mat-icon>assistant</mat-icon>

        IBN-Assistent

      </button>


      <button mat-stroked-button color="primary" type="button" [disabled]="exportiert" (click)="protokollExportieren()"
        matTooltip="Protokoll für das Projekt, eine Inbetriebnahme oder eine Messstelle als PDF">

        <mat-spinner diameter="18" *ngIf="exportiert">
        </mat-spinner>

        <ng-container *ngIf="!exportiert">

          <mat-icon>picture_as_pdf</mat-icon>

          <!--
            Zwei Beschriftungen, eine davon sichtbar: MDC-Knöpfe brechen
            ihren Text nicht um, die lange Fassung würde auf dem Handy
            aus dem Knopf laufen. Der Tooltip nennt weiterhin den
            vollständigen Sinn.
          -->
          <span class="label-lang">IBN-Protokoll exportieren</span>
          <span class="label-kurz">Protokoll</span>

        </ng-container>

      </button>

    </div>

  </div>


  <!-- LOADING -->
  <div class="loading" *ngIf="isLoading">

    <mat-spinner diameter="40">
    </mat-spinner>

  </div>


  <!-- FEHLER -->
  <mat-card class="hint-card" *ngIf="loadError">

    <mat-card-content>

      {{ loadError }}


      <div class="offline-ausweg" *ngIf="ohneVerbindung">

        <p>
          Bereits offline verfügbar gemachte Inbetriebnahmen
          lassen sich weiterhin öffnen und bearbeiten.
        </p>

        <button mat-raised-button color="primary" type="button" (click)="zuOfflineInbetriebnahmen()">

          <mat-icon>
            offline_pin
          </mat-icon>

          Zu den Offline-Inbetriebnahmen

        </button>

      </div>

    </mat-card-content>

  </mat-card>


  <ng-container *ngIf="!isLoading && projekt">


    <!-- =====================================================
       STAMMDATEN
       ===================================================== -->

    <mat-card class="section-card">

      <mat-card-content>


        <div class="section-head">

          <h2 class="section-title">
            Stammdaten
          </h2>


          <div class="section-actions" *ngIf="
              !editOpen
              &&
              (
                canEdit
                ||
                canManageProjektAccess
              )
            ">

            <button mat-stroked-button type="button" *ngIf="canEdit" (click)="bearbeiten()">

              <mat-icon>
                edit
              </mat-icon>

              Bearbeiten

            </button>


            <button mat-stroked-button type="button" *ngIf="canManageProjektAccess" (click)="zugriffVerwalten()">

              <mat-icon>
                group
              </mat-icon>

              Zugriff verwalten

            </button>


            <button mat-stroked-button color="warn" type="button" *ngIf="canEdit" (click)="loeschen()">

              <mat-icon>
                delete_outline
              </mat-icon>

              Löschen

            </button>

          </div>
        </div>

        <!-- ANZEIGE -->
        <div class="stamm-grid" *ngIf="!editOpen">


          <div class="stamm-item">

            <span class="stamm-label">
              Projektname
            </span>

            <span class="stamm-value">
              {{ projekt.name }}
            </span>

          </div>


          <div class="stamm-item">

            <span class="stamm-label">
              Projektnummer
            </span>

            <span class="stamm-value nummer">
              {{ projekt.projektNummer }}
            </span>

          </div>


          <div class="stamm-item">

            <span class="stamm-label">
              Kunde
            </span>

            <span class="stamm-value">
              {{ projekt.customerName || '–' }}
            </span>

          </div>


          <div class="stamm-item">

            <span class="stamm-label">
              Anlage
            </span>

            <span class="stamm-value">
              {{ projekt.equipmentName || '–' }}
            </span>

          </div>


          <div class="stamm-item">

            <span class="stamm-label">
              Angelegt
            </span>

            <span class="stamm-value">

              {{
              projekt.createdAtUtc
              | date:'dd.MM.yyyy HH:mm'
              }}

              <ng-container *ngIf="projekt.createdByName">

                · {{ projekt.createdByName }}

              </ng-container>

            </span>

          </div>

        </div>

        <!-- ===================================================== -->
        <!-- PROJEKTZUGRIFF -->
        <!-- ===================================================== -->

        <div class="zugriff-panel" *ngIf="zugriffOpen">

          <h3 class="zugriff-title">
            Projektzugriff verwalten
          </h3>

          <p class="zugriff-hint">
            Ausgewählte Benutzer können dieses Projekt sehen und öffnen.
            SuperAdmins haben automatisch Zugriff auf alle Projekte.
          </p>


          <div class="zugriff-loading" *ngIf="loadingZugriff">

            <mat-spinner diameter="28">
            </mat-spinner>

            <span>
              Benutzer werden geladen …
            </span>

          </div>


          <mat-form-field appearance="outline" class="zugriff-select" *ngIf="!loadingZugriff">

            <mat-label>
              Benutzer mit Projektzugriff
            </mat-label>

            <mat-select [(ngModel)]="ausgewaehlteUserIds" multiple [disabled]="savingZugriff">

              <!-- Im geschlossenen Dropdown nicht alle Namen hintereinander anzeigen -->
              <mat-select-trigger>

                <ng-container *ngIf="ausgewaehlteUserIds.length === 0">
                  Keine Benutzer ausgewählt
                </ng-container>

                <ng-container *ngIf="ausgewaehlteUserIds.length > 0">
                  {{ ausgewaehlteUserIds.length }}
                  Benutzer ausgewählt
                </ng-container>

              </mat-select-trigger>


              <mat-option *ngFor="let user of zugriffsBenutzer" [value]="user.id">

                <div class="zugriff-option">

                  <span class="zugriff-option-name">
                    {{ user.userName || user.email }}
                  </span>

                  <span class="zugriff-option-email" *ngIf="
            user.email
            &&
            user.email !== user.userName
          ">

                    {{ user.email }}

                  </span>

                </div>

              </mat-option>

            </mat-select>

            <mat-hint>
              Benutzer auswählen oder entfernen
            </mat-hint>

          </mat-form-field>

          <!-- AUSGEWÄHLTE BENUTZER -->
          <div class="zugriff-user-liste" *ngIf="
    !loadingZugriff
    &&
    ausgewaehlteBenutzer.length > 0
  ">

            <div class="zugriff-user" *ngFor="let user of ausgewaehlteBenutzer">

              <div class="zugriff-user-icon">
                <mat-icon>
                  person
                </mat-icon>
              </div>


              <div class="zugriff-user-info">

                <span class="zugriff-user-name">
                  {{ user.userName || user.email }}
                </span>

                <span class="zugriff-user-email" *ngIf="
          user.email
          &&
          user.email !== user.userName
        ">

                  {{ user.email }}

                </span>

              </div>


              <button mat-icon-button type="button" [disabled]="savingZugriff"
                (click)="zugriffBenutzerEntfernen(user.id)" matTooltip="Zugriff entfernen">

                <mat-icon>
                  close
                </mat-icon>

              </button>

            </div>

          </div>

          <div class="zugriff-keine-user" *ngIf="
    !loadingZugriff
    &&
    ausgewaehlteBenutzer.length === 0
  ">

            <mat-icon>
              group_off
            </mat-icon>

            Noch keine Benutzer ausgewählt.

          </div>


          <p class="form-error" *ngIf="zugriffError">

            <mat-icon>
              error_outline
            </mat-icon>

            {{ zugriffError }}

          </p>


          <div class="form-actions">

            <button mat-button type="button" [disabled]="savingZugriff" (click)="zugriffAbbrechen()">

              Abbrechen

            </button>


            <button mat-raised-button color="primary" type="button" [disabled]="
                  savingZugriff
                  ||
                  loadingZugriff
                " (click)="zugriffSpeichern()">

              <mat-spinner diameter="18" *ngIf="savingZugriff">
              </mat-spinner>

              <span *ngIf="!savingZugriff">
                Speichern
              </span>

            </button>

          </div>

        </div>

        <!-- BEARBEITEN -->
        <div *ngIf="editOpen">

          <div class="form-grid">


            <mat-form-field appearance="outline">

              <mat-label>
                Projektname
              </mat-label>

              <input matInput [(ngModel)]="form.name" [disabled]="saving">

            </mat-form-field>


            <mat-form-field appearance="outline">

              <mat-label>
                Projektnummer
              </mat-label>

              <input matInput [(ngModel)]="form.projektNummer" [disabled]="saving">

              <mat-hint>
                Muss eindeutig sein.
              </mat-hint>

            </mat-form-field>


            <mat-form-field appearance="outline">

              <mat-label>
                Kunde (optional)
              </mat-label>

              <mat-select [value]="form.customerId || null" (selectionChange)="onKundeChange($event.value)"
                [disabled]="saving">

                <mat-option [value]="null">
                  — kein Kunde —
                </mat-option>

                <mat-option *ngFor="let k of kunden" [value]="k.id">

                  {{ k.name }}

                </mat-option>

              </mat-select>

            </mat-form-field>


            <mat-form-field appearance="outline">

              <mat-label>
                Anlage (optional)
              </mat-label>

              <mat-select [(ngModel)]="form.equipmentId" [disabled]="
                saving
                ||
                !form.customerId
                ||
                loadingAnlagen
              ">

                <mat-option [value]="null">
                  — keine —
                </mat-option>

                <mat-option *ngFor="let a of anlagen" [value]="a.id">

                  {{ a.name }}

                  <span class="anlage-ort" *ngIf="a.location">

                    · {{ a.location }}

                  </span>

                </mat-option>

              </mat-select>


              <mat-hint *ngIf="!form.customerId">

                Nur mit zugeordnetem Kunden wählbar.

              </mat-hint>


              <mat-hint *ngIf="
                form.customerId
                &&
                loadingAnlagen
              ">

                Anlagen werden geladen …

              </mat-hint>


              <mat-hint *ngIf="
                form.customerId
                &&
                !loadingAnlagen
                &&
                anlagen.length === 0
              ">

                Für diesen Kunden ist keine Anlage hinterlegt.

              </mat-hint>

            </mat-form-field>

          </div>


          <p class="form-error" *ngIf="formError">

            <mat-icon>
              error_outline
            </mat-icon>

            {{ formError }}

          </p>


          <div class="form-actions">

            <button mat-button type="button" [disabled]="saving" (click)="abbrechen()">

              Abbrechen

            </button>


            <button mat-raised-button color="primary" type="button" [disabled]="
                  !istGueltig
                  ||
                  saving
                " (click)="speichern()">

              <mat-spinner diameter="18" *ngIf="saving">
              </mat-spinner>

              <span *ngIf="!saving">
                Speichern
              </span>

            </button>

          </div>

        </div>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
       GESAMTSTATUS
       ===================================================== -->

    <!-- =====================================================
       INBETRIEBNAHMEFORTSCHRITT

       Zwei getrennte Karten: links die bestehende Backend-Berechnung für
       Messstellen und Verbraucher (unverändert), rechts der SPS-Fortschritt
       aus dem SPS-Backend. Beide werden bewusst
       NICHT miteinander verrechnet.
       ===================================================== -->

    <div class="fortschritt-grid" *ngIf="projekt.inbetriebnahmenCount > 0 || spsFortschritt.gesamt > 0">

      <!-- A. MESSSTELLEN- UND VERBRAUCHERPRÜFUNG (Backend, unverändert) -->
      <mat-card class="section-card fortschritt-card" *ngIf="projekt.inbetriebnahmenCount > 0">

        <mat-card-content>

          <div class="status-head">

            <div class="status-title-wrap">

              <h2 class="section-title">
                <mat-icon class="fortschritt-icon">sensors</mat-icon>
                Messstellen- und Verbraucherprüfung
              </h2>

              <span class="status-badge" [class.status-badge-fertig]="projektIstFertig()"
                [class.status-badge-offen]="projektIstOffen()"
                [class.status-badge-nicht-gestartet]="projektIstNichtGestartet()">
                {{ projektStatusText() }}
              </span>

            </div>

            <span class="status-zahlen">
              {{ projekt.inbetriebnahmenCount }}
              Liste{{ projekt.inbetriebnahmenCount === 1 ? '' : 'n' }}
              · {{ projekt.messstellenGesamt }} Messstellen/Verbraucher
            </span>

          </div>


          <ng-container *ngIf="projekt.messstellenGesamt > 0">

            <mat-progress-bar mode="determinate" [value]="fortschrittProzent">
            </mat-progress-bar>

            <div class="status-grid">

              <div class="status-item">
                <span class="status-item-label">Gesamt</span>
                <strong>{{ projekt.messstellenGesamt }}</strong>
              </div>

              <div class="status-item">
                <span class="status-item-label">Gestartet</span>
                <strong>{{ projekt.messstellenGestartet }}</strong>
              </div>

              <div class="status-item">
                <span class="status-item-label">Abgeschlossen</span>
                <strong>{{ projekt.messstellenAbgeschlossen }}</strong>
              </div>

              <div class="status-item">
                <span class="status-item-label">Offen</span>
                <strong>{{ projekt.messstellenGesamt - projekt.messstellenAbgeschlossen }}</strong>
              </div>

              <div class="status-item">
                <span class="status-item-label">Fortschritt</span>
                <strong>{{ fortschrittProzent }} %</strong>
              </div>

            </div>

            <div class="status-text" *ngIf="projekt.pruefpunkteGesamt > 0">
              {{ projekt.pruefpunkteErledigt }} von {{ projekt.pruefpunkteGesamt }}
              vorhandenen Prüfpunkten abgearbeitet. Messstellen ohne Prüfpunkte
              zählen im Fortschritt mit 0 %.
            </div>

            <div class="status-warning" *ngIf="projekt.messstellenGestartet < projekt.messstellenGesamt">
              <mat-icon>info_outline</mat-icon>
              {{ projekt.messstellenGesamt - projekt.messstellenGestartet }}
              Messstelle{{ projekt.messstellenGesamt - projekt.messstellenGestartet === 1 ? '' : 'n' }}
              noch nicht gestartet.
            </div>

          </ng-container>

          <p class="empty-hint" *ngIf="projekt.messstellenGesamt === 0">
            Den Listen dieses Projekts sind noch keine Messstellen zugeordnet.
          </p>

        </mat-card-content>

      </mat-card>


      <!-- B. SPS-PRÜFUNG (SpsFortschritt aus dem Projekt-Detail) -->
      <mat-card class="section-card fortschritt-card fortschritt-card-sps" *ngIf="spsFortschritt.gesamt > 0">

        <mat-card-content>

          <div class="status-head">

            <div class="status-title-wrap">

              <h2 class="section-title">
                <mat-icon class="fortschritt-icon">developer_board</mat-icon>
                SPS-Prüfung
              </h2>

              <span class="status-badge" [class.status-badge-fertig]="spsStatusText === 'Geprüft'"
                [class.status-badge-offen]="spsStatusText === 'Offen'"
                [class.status-badge-nicht-gestartet]="spsStatusText === 'Nicht gestartet'">
                {{ spsStatusText }}
              </span>


            </div>

            <span class="status-zahlen">
              {{ spsFortschritt.gesamt }} Signale
              · {{ spsFortschritt.reserve }} Reserve
            </span>

          </div>


          <mat-progress-bar mode="determinate" [value]="spsFortschritt.bearbeitetProzent">
          </mat-progress-bar>

          <div class="status-grid">

            <div class="status-item">
              <span class="status-item-label">Prüfbar</span>
              <strong>{{ spsFortschritt.pruefbar }}</strong>
            </div>

            <div class="status-item">
              <span class="status-item-label">Bearbeitet</span>
              <strong>{{ spsFortschritt.bearbeitet }}</strong>
            </div>

            <div class="status-item">
              <span class="status-item-label">Davon OK</span>
              <strong class="wert-ok">{{ spsFortschritt.ok }}</strong>
            </div>

            <div class="status-item">
              <span class="status-item-label">Davon NOK</span>
              <strong [class.wert-nok]="spsFortschritt.nichtOk > 0">{{ spsFortschritt.nichtOk }}</strong>
            </div>

            <div class="status-item">
              <span class="status-item-label">Ungeprüft</span>
              <strong>{{ spsFortschritt.ungeprueft }}</strong>
            </div>

            <div class="status-item">
              <span class="status-item-label">Fortschritt</span>
              <strong>{{ spsFortschritt.bearbeitetProzent }} %</strong>
            </div>

          </div>

          

          <div class="status-warning" *ngIf="spsFortschritt.nichtOk > 0">
            <mat-icon>error_outline</mat-icon>
            {{ spsFortschritt.nichtOk }} Signal{{ spsFortschritt.nichtOk === 1 ? '' : 'e' }} mit NOK –
            in der SPS-Prüfung nachsehen.
          </div>

          <div class="fortschritt-aktion">
            <button mat-stroked-button color="primary" type="button" (click)="zurSpsPruefung()">
              <mat-icon>fact_check</mat-icon>
              SPS-Prüfung öffnen
            </button>
          </div>

        </mat-card-content>

      </mat-card>

    </div>


    <!-- =====================================================
       FORTSCHRITT JE ANLAGENTEIL
       ===================================================== -->

    <mat-card class="detail-card" *ngIf="zeigeAnlagenteilFortschritt">

      <mat-card-content>


        <h2 class="card-title">

          <mat-icon>
            account_tree
          </mat-icon>

          Fortschritt je Anlagenteil

        </h2>

        


        <div class="anlagenteil-ibn-gruppen">


          <section class="anlagenteil-ibn-gruppe" *ngFor="
            let gruppe of anlagenteilGruppen;
            trackBy: trackByGruppe
          ">


            <header class="ibn-gruppe-kopf">

              <div class="ibn-gruppe-titel">

                <mat-icon inline>
                  table_rows
                </mat-icon>

                <span class="ibn-gruppe-name">
                  {{ gruppe.inbetriebnahmeName }}
                </span>

              </div>


              <span class="ibn-gruppe-meta">

                Inbetriebnahme

                <ng-container *ngIf="gruppe.messstellenGesamt > 0">

                  ·

                  {{ gruppe.messstellenGesamt }}

                  Messstelle{{
                  gruppe.messstellenGesamt === 1
                  ? ''
                  : 'n'
                  }}

                </ng-container>

              </span>

            </header>


            <div class="anlagenteil-grid">


              <div class="anlagenteil-kachel" *ngFor="
                let a of gruppe.anlagenteile;
                trackBy: trackByAnlagenteil
              ">


                <svg class="ring" viewBox="0 0 44 44" aria-hidden="true">

                  <circle class="ring-spur" cx="22" cy="22" r="19">
                  </circle>

                  <circle class="ring-wert" cx="22" cy="22" r="19" [attr.stroke-dasharray]="ringUmfang"
                    [attr.stroke-dashoffset]="ringOffset(a.fortschrittProzent)">
                  </circle>

                </svg>


                <div class="anlagenteil-text">

                  <span class="anlagenteil-name">
                    {{ a.name }}
                  </span>

                  <span class="anlagenteil-prozent">
                    {{ a.fortschrittProzent }} %
                  </span>

                  <span class="anlagenteil-zahlen">

                    {{ a.messstellenGesamt }}

                    Messstelle{{
                    a.messstellenGesamt === 1
                    ? ''
                    : 'n'
                    }}

                    <ng-container *ngIf="a.messstellenAbgeschlossen > 0">

                      ·
                      {{ a.messstellenAbgeschlossen }}
                      fertig

                    </ng-container>

                  </span>

                </div>

              </div>

            </div>


            <p class="ibn-gruppe-hinweis" *ngIf="
              gruppe.messstellenOhneAnlagenteil
              >
              0
            ">

              <mat-icon inline>
                info_outline
              </mat-icon>

              {{ gruppe.messstellenOhneAnlagenteil }}

              Messstelle{{
              gruppe.messstellenOhneAnlagenteil === 1
              ? ''
              : 'n'
              }}

              ohne Anlagenteil – nicht in den Ringen enthalten.

            </p>

          </section>


          <!-- SPS-PRÜFUNG JE ANLAGENTEIL (ProjektDetailDto.SpsAnlagenteile) -->
          <section class="anlagenteil-ibn-gruppe anlagenteil-ibn-gruppe-sps"
            *ngIf="spsAnlagenteile.anlagenteile.length > 0">

            <header class="ibn-gruppe-kopf">

              <div class="ibn-gruppe-titel">

                <mat-icon inline>
                  developer_board
                </mat-icon>

                <span class="ibn-gruppe-name">
                  SPS-Prüfung
                </span>

              </div>

              <span class="ibn-gruppe-meta">
                SPS-Signale · {{ spsAnlagenteile.signaleGesamt }}
                Signal{{ spsAnlagenteile.signaleGesamt === 1 ? '' : 'e' }}
                · bearbeitet / gesamt je Anlagenteil
              </span>

            </header>


            <div class="anlagenteil-grid">

              <div class="anlagenteil-kachel" *ngFor="
                let a of spsAnlagenteile.anlagenteile;
                trackBy: trackBySpsAnlagenteil
              ">

                <svg class="ring" viewBox="0 0 44 44" aria-hidden="true">

                  <circle class="ring-spur" cx="22" cy="22" r="19">
                  </circle>

                  <circle class="ring-wert ring-wert-sps" cx="22" cy="22" r="19" [attr.stroke-dasharray]="ringUmfang"
                    [attr.stroke-dashoffset]="ringOffset(a.fortschritt.bearbeitetProzent)">
                  </circle>

                </svg>


                <div class="anlagenteil-text">

                  <span class="anlagenteil-name">
                    {{ a.name }}
                  </span>

                  <span class="anlagenteil-prozent">
                    {{ a.fortschritt.bearbeitetProzent }} %
                  </span>

                  <span class="anlagenteil-zahlen">

                    {{ a.fortschritt.gesamt }}
                    Signal{{ a.fortschritt.gesamt === 1 ? '' : 'e' }}
                    · {{ a.fortschritt.bearbeitet }} bearbeitet

                    <ng-container *ngIf="a.fortschritt.nichtOk > 0">
                      · <span class="wert-nok">{{ a.fortschritt.nichtOk }} NOK</span>
                    </ng-container>

                  </span>

                </div>

              </div>

            </div>


            <p class="ibn-gruppe-hinweis" *ngIf="spsAnlagenteile.signaleOhneAnlagenteil > 0">

              <mat-icon inline>
                info_outline
              </mat-icon>

              {{ spsAnlagenteile.signaleOhneAnlagenteil }}
              Signal{{ spsAnlagenteile.signaleOhneAnlagenteil === 1 ? '' : 'e' }}
              ohne Anlagenteil – nicht in den Ringen enthalten.

            </p>

            <p class="ibn-gruppe-hinweis" *ngIf="spsAnlagenteile.signaleMehrdeutig > 0">

              <mat-icon inline>
                help_outline
              </mat-icon>

              {{ spsAnlagenteile.signaleMehrdeutig }}
              Signal{{ spsAnlagenteile.signaleMehrdeutig === 1 ? '' : 'e' }}
              mit widersprüchlichen oder ungeklärten Anlagenteil-Quellen – keinem Ring zugeordnet.

            </p>

          </section>

        </div>


    

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
       PROJEKTLISTEN

       Alle importierten Listen des Projekts als kompakte Zeilen. Die echten
       Inbetriebnahmen (Messstellen-/Verbraucherlisten) kommen unverändert
       vom Server und führen zur bestehenden Prüfung. Dahinter die SPS-Listen aus dem SPS-Import – sie zeigen technische Daten, geprüft wird zentral unter „Prüfungen“.
       ===================================================== -->

    <mat-card class="section-card" data-wizard-target="projekt-inbetriebnahmen">

      <mat-card-content>

        <div class="section-head">

          <h2 class="section-title">
            Projektlisten
            <span class="section-count">{{ anzahlListen }}</span>
          </h2>

          <div class="section-head-aktionen" *ngIf="canEdit">
            <button mat-stroked-button type="button" (click)="neueLeereListe()"
              matTooltip="Inbetriebnahmeliste ohne Excel erstellen – Spalten selbst festlegen oder Vorlage verwenden">
              <mat-icon>playlist_add</mat-icon>
              Leere Liste erstellen
            </button>

            <button mat-raised-button color="primary" type="button" (click)="zumMehrfachimport()"
              matTooltip="Messstellen-, Verbraucher-, SPS-Zuordnungs- oder PLC-Tag-Liste hinzufügen">
              <mat-icon>add</mat-icon>
              Listen importieren
            </button>
          </div>

        </div>

        <div class="projektlisten-gruppen">
          <section class="projektlisten-gruppe" aria-labelledby="listen-messstellen-titel">
            <div class="projektlisten-gruppe-kopf">
              <mat-icon>fact_check</mat-icon>
              <div>
                <h3 id="listen-messstellen-titel">Messstellen &amp; Verbraucher</h3>
                
              </div>
              <span class="projektlisten-gruppe-anzahl">{{ projekt.inbetriebnahmen.length }}</span>
            </div>
            <p class="empty-hint" *ngIf="projekt.inbetriebnahmen.length === 0">Noch keine Messstellen- oder
              Verbraucherliste importiert.</p>
            <div class="listen">

              <!--
                EIN Menü für alle Messstellen-/Verbraucherlisten. Der Inhalt
                entsteht erst beim Öffnen, die Zeile kommt über matMenuTriggerData.
              -->
              <mat-menu #listeMenu="matMenu" xPosition="before" class="liste-menu">
                <ng-template matMenuContent let-inb="inb">
                  <button mat-menu-item type="button" (click)="listeBearbeiten(inb)">
                    <mat-icon>edit</mat-icon>
                    <span>Bearbeiten</span>
                  </button>
                  <button mat-menu-item type="button" (click)="listeDuplizieren(inb)">
                    <mat-icon>content_copy</mat-icon>
                    <span>Duplizieren</span>
                  </button>
                  <button mat-menu-item type="button" class="liste-menu-loeschen" (click)="deleteListe(inb)">
                    <mat-icon>delete_outline</mat-icon>
                    <span>Löschen</span>
                  </button>
                </ng-template>
              </mat-menu>


              <!-- ECHTE LISTEN: Messstellen- und Verbraucherlisten -->
              <div class="liste-zeile" *ngFor="
            let inb of projekt.inbetriebnahmen;
            trackBy: trackByInbetriebnahme
          " [class.liste-fertig]="istFertig(inb)" [class.liste-offen]="istOffen(inb)"
                [class.liste-nicht-gestartet]="istNichtGestartet(inb)">

                <div class="liste-haupt" role="button" tabindex="0" (click)="oeffneInbetriebnahme(inb)"
                  (keydown.enter)="oeffneInbetriebnahme(inb)" matTooltip="Liste öffnen und prüfen"
                  [matTooltipDisabled]="istListeInBearbeitung(inb.id)">

                  <mat-icon class="liste-icon">{{ listenTypInfoVon(inb).icon }}</mat-icon>

                  <div class="liste-text">

                    <!--
                      Der Titel wird beim Umbenennen an seiner Stelle zum Eingabefeld.
                      Klicks und Tasten darin dürfen die Zeile nicht öffnen.
                    -->
                    <span class="liste-name" *ngIf="!istListeInBearbeitung(inb.id); else listeNameBearbeiten">
                      {{ inb.name }}
                    </span>

                    <ng-template #listeNameBearbeiten>
                      <div class="liste-name-bearbeiten" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()">

                        <input #listeNameEingabe type="text" class="liste-name-eingabe"
                          [(ngModel)]="listeNameEntwurf" [disabled]="listeNameSpeichert" maxlength="200"
                          autocomplete="off" spellcheck="false" aria-label="Neuer Name der Liste"
                          [attr.aria-invalid]="listeNameFehler ? 'true' : null"
                          [class.liste-name-eingabe-fehler]="!!listeNameFehler"
                          (keydown)="listeNameTaste($event)">

                        <button mat-icon-button type="button" class="liste-name-ok"
                          [disabled]="listeNameSpeichert || !listeNameEntwurf.trim()"
                          (click)="listeBearbeitenSpeichern()" matTooltip="Speichern (Enter)"
                          aria-label="Namen speichern">
                          <mat-spinner diameter="18" *ngIf="listeNameSpeichert"></mat-spinner>
                          <mat-icon *ngIf="!listeNameSpeichert">check</mat-icon>
                        </button>

                        <button mat-icon-button type="button" class="liste-name-abbrechen"
                          [disabled]="listeNameSpeichert" (click)="listeBearbeitenAbbrechen()"
                          matTooltip="Abbrechen (Esc)" aria-label="Umbenennen abbrechen">
                          <mat-icon>close</mat-icon>
                        </button>

                      </div>

                      <span class="liste-name-fehler" role="alert" *ngIf="listeNameFehler">
                        <mat-icon>error_outline</mat-icon>{{ listeNameFehler }}
                      </span>
                    </ng-template>

                    <span class="liste-meta">
                      <span class="liste-typ">{{ listenTypInfoVon(inb).titel }}</span>
                      <span>· {{ inb.messstellenCount }} Einträge</span>
                      <span *ngIf="inb.importedAtUtc">· {{ inb.importedAtUtc | date:'dd.MM.yyyy' }}</span>
                      <span *ngIf="inb.importedByName">· {{ inb.importedByName }}</span>
                    </span>

                  </div>

                  <div class="liste-status">

                    <span class="status-badge" [class.status-badge-fertig]="istFertig(inb)"
                      [class.status-badge-offen]="istOffen(inb)"
                      [class.status-badge-nicht-gestartet]="istNichtGestartet(inb)">
                      {{ inbetriebnahmeStatusText(inb) }}
                    </span>

                    <div class="liste-progress" *ngIf="inb.messstellenCount > 0">
                      <mat-progress-bar mode="determinate" [value]="inbetriebnahmeProzent(inb)">
                      </mat-progress-bar>
                      <span class="liste-progress-text">
                        {{ inb.messstellenAbgeschlossen }} / {{ inb.messstellenCount }} geprüft
                        · {{ inbetriebnahmeProzent(inb) }} %
                      </span>
                    </div>

                    <span class="liste-keine" *ngIf="inb.messstellenCount === 0">
                      noch keine Einträge
                    </span>

                  </div>

                  <!--
                    Ein Drei-Punkte-Menü statt Einzelknöpfen. Klicks und Tasten
                    bleiben hier – die Zeile dahinter würde sonst die Liste öffnen.
                  -->
                  <div class="liste-aktionen" (click)="listeAktionenKlick($event)"
                    (keydown)="listeAktionenKlick($event)">

                    <button mat-icon-button type="button" class="liste-menu-button" *ngIf="canEdit"
                      [matMenuTriggerFor]="listeMenu" [matMenuTriggerData]="{ inb: inb }"
                      [disabled]="istListeBeschaeftigt(inb.id)"
                      [attr.aria-label]="'Aktionen für ' + inb.name"
                      [matTooltip]="istListeAmDuplizieren(inb.id) ? 'Wird dupliziert …' : 'Aktionen'">
                      <mat-spinner diameter="20" *ngIf="istListeBeschaeftigt(inb.id)"></mat-spinner>
                      <mat-icon *ngIf="!istListeBeschaeftigt(inb.id)">more_vert</mat-icon>
                    </button>

                    <mat-icon class="liste-chevron">chevron_right</mat-icon>

                  </div>

                </div>

                <!-- Offline-Download bleibt wie bisher an der Liste -->
                <app-offline-kachel class="liste-offline" [inbetriebnahme]="inb" (geaendert)="neuLaden()">
                </app-offline-kachel>

              </div>


            </div>
          </section>

          <section class="projektlisten-gruppe" aria-labelledby="listen-sps-titel">
            <div class="projektlisten-gruppe-kopf">
              <mat-icon>developer_board</mat-icon>
              <div>
                <h3 id="listen-sps-titel">
                  <a href="javascript:void(0)" class="projektlisten-gruppe-link" (click)="zurSpsListenUebersicht()"
                    matTooltip="Alle SPS-Listen öffnen, ansehen und löschen">SPS-Listen</a>
                </h3>
                
              </div>
              <span class="projektlisten-gruppe-anzahl">{{ spsListen.length }}</span>
              <button mat-stroked-button type="button" class="projektlisten-gruppe-aktion"
                (click)="zurSpsListenUebersicht()">
                <mat-icon>list_alt</mat-icon>
                Alle SPS-Listen
              </button>
            </div>
            <p class="empty-hint" *ngIf="spsListen.length === 0 && !spsListenFehler">Noch keine SPS-Listen importiert.
            </p>
            <p class="form-error" *ngIf="spsListenFehler"><mat-icon>error_outline</mat-icon>{{ spsListenFehler }}</p>
            <div class="listen">
              <!-- SPS-LISTEN: SPS-Zuordnungsliste und PLC-Tag-Liste (SpsImportApiService) -->
              <div class="liste-zeile liste-sps" *ngFor="
            let liste of spsListen;
            trackBy: trackBySpsListe
          ">

                <div class="liste-haupt" role="button" tabindex="0" (click)="oeffneSpsListe(liste)"
                  (keydown.enter)="oeffneSpsListe(liste)" [matTooltip]="spsListenTypInfo(liste).titel + ' öffnen'">

                  <mat-icon class="liste-icon">{{ spsListenTypInfo(liste).icon }}</mat-icon>

                  <div class="liste-text">

                    <span class="liste-name">{{ liste.name }}</span>

                    <span class="liste-meta">
                      <span class="liste-typ">{{ spsListenTypInfo(liste).titel }}</span>
                      <span>· {{ liste.eintraegeAnzahl }} Einträge</span>
                      <span>· {{ liste.importiertAmUtc | date:'dd.MM.yyyy' }}</span>
                      <span *ngIf="liste.importiertVon">· {{ liste.importiertVon }}</span>
                    </span>

                  </div>

                  <div class="liste-status">
                    <span class="liste-hinweis">Technische Daten · geprüft wird unter „Prüfungen“</span>
                    <span class="liste-hinweis" *ngIf="liste.signaleUngeklaert > 0">{{ liste.signaleUngeklaert }}
                      ungeklärte Zuordnung{{ liste.signaleUngeklaert === 1 ? '' : 'en' }}</span>
                  </div>

                  <div class="liste-aktionen">

                    <button mat-icon-button class="delete-button" color="warn" type="button" *ngIf="canEdit"
                      [disabled]="istSpsListeAmLoeschen(liste.id)" (click)="deleteSpsListe(liste, $event)"
                      matTooltip="SPS-Liste löschen">
                      <mat-spinner diameter="20" *ngIf="istSpsListeAmLoeschen(liste.id)"></mat-spinner>
                      <mat-icon *ngIf="!istSpsListeAmLoeschen(liste.id)">delete_outline</mat-icon>
                    </button>

                    <mat-icon class="liste-chevron">chevron_right</mat-icon>

                  </div>

                </div>

              </div>

            </div>
          </section>
        </div>

      </mat-card-content>

    </mat-card>





  </ng-container>

</div>